import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationsEn from './translations/translations.en.json';
import translationsEs from './translations/translations.es.json';
import { DEFAULT_LANGUAGE, resolveInitialLanguage, SUPPORTED_LANGUAGES } from './language';
import { initMomentLocale } from './moment-locale';

i18next
    .use(initReactI18next)
    .init({
        lng: resolveInitialLanguage(),
        fallbackLng: DEFAULT_LANGUAGE,
        supportedLngs: SUPPORTED_LANGUAGES,
        resources: {
            en: {
                translation: translationsEn,
            },
            es: {
                translation: translationsEs,
            },
        },
        interpolation: {
            format: (value, format) => {
                if (format === 'capitalize' && typeof value === 'string' && value.length > 0) {
                    return value.charAt(0).toUpperCase() + value.slice(1);
                }
                return value;
            },
        },
    })
    .then((): null => {
        initMomentLocale();
        return null;
    });

export default i18next;
